// extracted by mini-css-extract-plugin
export var falconContainer = "_w7-2";
export var offerCenter = "_w7-0";
export var roktContainer = "_w7-1";